'use strict';

import FormController from 'app/controllers/form';

class CreditorController extends FormController {
  /* @ngInject */
  constructor(
    CreditorsService,
    $scope,
    $mdDialog,
    $mdToast,
    $state,
    $location
  ) {
    let creditor = $scope.$parent.$resolve.creditor;
    super(creditor, 'Acreedor', CreditorsService, null, 'creditors');

    Object.assign(this, {
      CreditorsService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
    this.btnEnabled = true;
  }
}

export default CreditorController;
